import { getIsAdditionalPlanCode } from './getIsAdditionalPlanCode';
import { getIsCustomCargoOwnerPlanCode } from './getIsCustomCargoOwnerPlanCode';
import {
  TBillingAdditionalPlanCode,
  TBillingCustomCargoOwnerPlanCode,
  TPlanCode,
} from './types';

export const isAdditionalPlanCodeGuard = (
  planCode: TPlanCode | null | undefined):
    planCode is TBillingAdditionalPlanCode => getIsAdditionalPlanCode(planCode);

export const isCustomCargoOwnerPlanCodeGuard = (
  planCode: TPlanCode | null | undefined):
        planCode is TBillingCustomCargoOwnerPlanCode => getIsCustomCargoOwnerPlanCode(planCode);
